import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 8px;\n  path {\n    &[fill] {\n      stroke: ", " !important;\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 5px;\n  align-items: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n  font-size: 14px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      margin-top: 5px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  user-select: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled, { css } from '../utils/styling/styled-components';
import { Heading } from '../Typography/Heading';
import { Heading2 } from '../Typography/Heading2';
import { Bodytext } from '../Typography/Bodytext';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.ivoryLight;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.ivory;
});
var TextContainer = styled.div(_templateObject2());
var Title = styled(Heading)(_templateObject3());
var StyledBody = styled(Bodytext)(_templateObject4(), function (props) {
  return props.hasTitle && css(_templateObject5());
});
var StyledHeading2 = styled(Heading2)(_templateObject6(), function (props) {
  return props.theme.colors.green;
});
var Content = styled.div(_templateObject7());
var CallToActionContainer = styled.div(_templateObject8());
var StyledChevronRight = styled(AcornsIcon)(_templateObject9(), function (props) {
  return props.theme.colors.green;
});

var InfoNote = function InfoNote(props) {
  var _props$icon;

  return /*#__PURE__*/React.createElement(Container, {
    className: props === null || props === void 0 ? void 0 : props.className
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: (_props$icon = props === null || props === void 0 ? void 0 : props.icon) !== null && _props$icon !== void 0 ? _props$icon : AcornsIcon.Icon.ProductGrow,
    width: "24px",
    height: "24px"
  })), /*#__PURE__*/React.createElement(TextContainer, null, (props === null || props === void 0 ? void 0 : props.title) && /*#__PURE__*/React.createElement(Title, null, props === null || props === void 0 ? void 0 : props.title), (props === null || props === void 0 ? void 0 : props.body) && /*#__PURE__*/React.createElement(StyledBody, {
    hasTitle: !!(props === null || props === void 0 ? void 0 : props.title)
  }, props === null || props === void 0 ? void 0 : props.body), (props === null || props === void 0 ? void 0 : props.callToActionLabel) && /*#__PURE__*/React.createElement(CallToActionContainer, null, /*#__PURE__*/React.createElement(StyledHeading2, null, props.callToActionLabel), /*#__PURE__*/React.createElement(StyledChevronRight, {
    icon: AcornsIcon.Icon.ChevronRight,
    height: '9px'
  })))));
};

export { InfoNote };